import { render, staticRenderFns } from "./OffensiveRatingDiagram.vue?vue&type=template&id=5a3afdc0&scoped=true&"
import script from "./OffensiveRatingDiagram.vue?vue&type=script&lang=js&"
export * from "./OffensiveRatingDiagram.vue?vue&type=script&lang=js&"
import style0 from "./OffensiveRatingDiagram.vue?vue&type=style&index=0&id=5a3afdc0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3afdc0",
  null
  
)

export default component.exports